import API from "../api/axios";

export const getAllLeads = (params) => {
   return API.get("/leads", { params });
};

export const createLead = (data) => {
   return API.post("/leads", data);
};

export const updateLead = (id, data) => {
   return API.put(`/leads/${id}`, data);
};

export const deleteLead = (id) => {
   return API.delete(`/leads/${id}`);
};

export const bulkDeleteLeads = async (ids) => {
   if (!ids || ids.length === 0) {
      throw new Error("No leads selected");
   }

   try {
      const res = await API.delete("/leads/bulk-delete", {
         data: { ids },
      });
      return res.data;
   } catch (err) {
      console.error(
         "Bulk Delete Leads Error:",
         err.response?.data || err.message
      );
      throw err;
   }
};

export const importLeads = (formData) => {
   return API.post("/leads/import", formData);
};

// export const exportLeads = () => {
//    return API.get("/leads/export", { responseType: "blob" });
// };

export const exportLeads = (params) => {
   return API.get("/leads/export", {
      params,
      responseType: "blob"
   });
};

export const convertLead = (id, data) => {
   return API.post(`/leads/${id}/convert`, data);
};

export const bulkAssignLeads = (data) => {
   return API.post("/leads/bulk-assign", data);
};

export const bulkAssignProject = async (data) => {
   try {
      const res = await API.post("/leads/bulk-assign-project", data);
      return res.data;
   } catch (err) {
      console.error("Bulk Project Assignment Error:", err.response?.data || err.message);
      throw err;
   }
};

export const bulkUpdateStatus = async (data) => {
   try {
      const res = await API.put("/leads/bulk-status", data);
      return res.data;
   } catch (err) {
      console.error("Bulk Status Update Error:", err.response?.data || err.message);
      throw err;
   }
};